import { XMarkIcon } from '@heroicons/react/24/outline';

interface HelpModalProps {
  visible: boolean;
  onClose: () => void;
}

export function HelpModal({ visible, onClose }: HelpModalProps) {
  if (!visible) return null;

  return (
    <>
      <div className="overlay visible" onClick={onClose} />
      <div className="modal visible">
        <button className="close-button" onClick={onClose}><XMarkIcon style={{ width: '20px', height: '20px' }} /></button>
        <h3>4D YOU</h3>

        <p>
          <span className="key">↑↓←→</span> Move | <span className="key">1-4</span> Switch Dimension | <span className="key">R</span> Restart
        </p>

        <div className="section">
          <p style={{ color: '#00ff00', fontSize: '10px' }}>OBJECTIVE</p>
          <p>Your <span style={{ color: '#00ffff' }}>CYAN CHARACTER (YOU)</span> must reach the <span style={{ color: '#ff00ff' }}>PURPLE PORTAL (GOAL)</span> in dimension 1!</p>
          <p>Create rules in dimensions 2-4, then use them in dimension 1 to solve the puzzle!</p>
        </div>

        <div className="section">
          <p style={{ color: '#ff00ff', fontSize: '10px' }}>4 DIMENSIONS</p>
          <p><span className="key">1</span> <span style={{ color: '#00ffff' }}>CYAN</span> - Main dimension (solve here!)</p>
          <p><span className="key">2</span> <span style={{ color: '#ff00ff' }}>MAGENTA</span> - Word boxes visible</p>
          <p><span className="key">3</span> <span style={{ color: '#00ff00' }}>GREEN</span> - Word boxes visible</p>
          <p><span className="key">4</span> <span style={{ color: '#ffaa00' }}>ORANGE</span> - Word boxes visible</p>
        </div>

        <div className="section">
          <p style={{ color: '#00ffff', fontSize: '10px' }}>HOW TO PLAY</p>
          <p>1. Switch to dimension 2, 3, or 4</p>
          <p>2. Walk over word boxes to connect them</p>
          <p>3. Form rules: [NOUN] [IS] [PROPERTY]</p>
          <p>4. Touch connected box to reset from that point</p>
          <p>5. Return to dimension 1 to use rules and win!</p>
          <p>6. Word boxes glow GOLDEN when part of active rules!</p>
        </div>

        <div className="section">
          <p style={{ color: '#00ff00', fontSize: '10px' }}>OBJECTS</p>
          <p><span style={{ color: '#00ffff' }}>●</span> <span className="highlight">PHANTOM (YOU)</span> - Cyan circle with face - Your character</p>
          <p><span style={{ color: '#ff00ff' }}>◉</span> <span className="highlight">PORTAL (GOAL)</span> - Purple swirl - The exit/win condition</p>
          <p><span style={{ color: '#4169E1' }}>▪</span> <span className="highlight">BARRIER</span> - Blue grid - Walls that block you</p>
          <p><span style={{ color: '#FFD700' }}>●</span> <span className="highlight">ORB</span> - Golden sphere - Can be pushed</p>
          <p><span style={{ color: '#00FF00' }}>◆</span> <span className="highlight">CRYSTAL (GEM)</span> - Green diamond - Grants phasing</p>
          <p><span style={{ color: '#8B4513' }}>◆</span> <span className="highlight">ROCK</span> - Brown stone - Can be pushed or transformed</p>
          <p><span style={{ color: '#1E90FF' }}>~</span> <span className="highlight">WATER</span> - Blue liquid - Can sink objects</p>
          <p><span style={{ color: '#FF4500' }}>▲</span> <span className="highlight">FIRE</span> - Orange flame - Can be hot</p>
          <p><span style={{ color: '#FFD700' }}>⚷</span> <span className="highlight">KEY</span> - Gold key - Opens doors</p>
          <p><span style={{ color: '#8B4513' }}>▮</span> <span className="highlight">DOOR</span> - Brown door - Blocks when shut</p>
        </div>

        <div className="section">
          <p style={{ color: '#FFD700', fontSize: '10px' }}>TIPS</p>
          <p>• Each dimension has different word boxes</p>
          <p>• You can only WIN in dimension 1</p>
          <p>• Purple particles = connect, Red = disconnect</p>
          <p>• Check the ACTIVE RULES panel to see what rules are working!</p>
        </div>
      </div>
    </>
  );
}
